export default "/institutions/inter.svg";